import { render } from "./setDekNumModel.vue?vue&type=template&id=5c206c5e"
import script from "./setDekNumModel.vue?vue&type=script&lang=js"
export * from "./setDekNumModel.vue?vue&type=script&lang=js"

import "./setDekNumModel.vue?vue&type=style&index=0&id=5c206c5e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__